/* tslint:disable:component-selector component-class-suffix no-trailing-whitespace */

import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit
} from '@angular/core';

import { Tab } from './tab';

@Component({
  selector: 'tabs',
  template: `
    <ul class="nav nav-tabs">
      <li *ngFor="let tab of tabs" class="nav-item" (click)="selectTab(tab, $event)" [class.active]="tab.active">
        <a class="nav-link" href="#">{{tab.title}}</a>
      </li>
    </ul>
    <ng-content></ng-content>
  `,
  styles: [
    `
    `
  ]
})

/**
 *
 * @class Tabs
 *
 * @brief tab container, renders multiple tabs together
 *
 * @link https://juristr.com/blog/2016/02/learning-ng2-creating-tab-component/
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      October 2019
 *
 */
export class Tabs implements AfterContentInit {

  @ContentChildren(Tab) tabs: QueryList<Tab>;

  /* contentChildren are set */

  ngAfterContentInit() {

    /* get all active tabs */

    const activeTabs = this.tabs.filter( (tab) => tab.active);

    /* if there is no active tab set, activate the first */

    if (activeTabs.length === 0) {

      this.selectTab(this.tabs.first);
    }
  }

  selectTab(tab: Tab, event: MouseEvent = null) {

    if (event) {

      event.stopPropagation();
    }

    /* deactivate all tabs */

    this.tabs.toArray().forEach(x => {
      x.active = false;
      x.deactivate();
    });

    /* activate the tab the user has clicked on. */

    tab.active = true;
    tab.activate();
  }

  tabOfTitle(title: string): Tab {

    return this.tabs.find(tab => tab.title.toLowerCase() === title.toLowerCase());
  }

  selectTabByTitle(title: string) {

    const tab: Tab = this.tabOfTitle(title);
    this.selectTab(tab);
  }
}
